// extracted by mini-css-extract-plugin
export default {"searchLabel":"CustomerSearch_searchLabel__sB7zO","searchFormControl":"CustomerSearch_searchFormControl__r3MAb"};